document.addEventListener("DOMContentLoaded", () => {
    const homeBanner = document.querySelector(".home__data");
    const wrapHomeBanner = document.querySelector(".wrap-home-banner");
    const companyBanner = document.querySelector(".company");
    const wrapCompanyBanner = document.querySelector(".wraper-company");
    const casesBanner = document.querySelector(".banner__cases .wraper-banner");
    const wrapCasesBanner = document.querySelector(
        ".banner__cases .inside-banner"
    );
    const overlayLoader = document.querySelector(".overlay-loader");
    const progressBar = document.querySelector(".progress-fill");
    const pageCompany = document.querySelector(".page__company");
    const pageCases = document.querySelector(".page__cases");
    const isHomePage = document.body.classList.contains("page__home");
    const isDesktop = window.innerWidth >= 992;

    const transitionOverlay = document.createElement("div");
    transitionOverlay.classList.add("page-transition");
    document.body.appendChild(transitionOverlay);

    function waitForFirstThreeImagesInCasesHome(timeout = 5000) {
        return new Promise((resolve) => {
            const casesHome = document.querySelector(".cases-home");
            if (!casesHome) return resolve();

            const images = Array.from(casesHome.querySelectorAll("img")).slice(0, 1);

            if (images.length === 0) return resolve();

            let loadedCount = 0;
            let resolved = false;

            const checkDone = () => {
                if (loadedCount >= images.length && !resolved) {
                    resolved = true;
                    resolve();
                }
            };

            images.forEach((img) => {
                if (img.complete) {
                    loadedCount++;
                    checkDone();
                } else {
                    img.addEventListener("load", () => {
                        loadedCount++;
                        checkDone();
                    });
                    img.addEventListener("error", () => {
                        loadedCount++;
                        checkDone();
                    });
                }
            });

            setTimeout(() => {
                if (!resolved) {
                    resolved = true;
                    resolve();
                }
            }, timeout);
        });
    }

    function startLoader() {
        let count = 0;
        let paused = false;
        let firstThreeImagesLoaded = false;
        const counterDuration = isDesktop ? 2500 : 3000;
        const intervalTime = counterDuration / 100;

        const imagePromise = isHomePage && !isDesktop
            ? waitForFirstThreeImagesInCasesHome(5000)
            : Promise.resolve();

        imagePromise.then(() => {
            firstThreeImagesLoaded = true;
        });

        const counterPromise = new Promise((resolve) => {
            const interval = setInterval(() => {
                if (paused) return;

                count++;
                if (progressBar) {
                    progressBar.style.width = count + "%";
                }

                if (isHomePage && !isDesktop && count >= 80 && !firstThreeImagesLoaded) {
                    paused = true;
                    return;
                }

                if (count >= 100) {
                    clearInterval(interval);
                    resolve();
                }
            }, intervalTime);
        });

        Promise.all([counterPromise, imagePromise]).then(() => {
            if (!isDesktop) {
                const progressBar = document.querySelector(".progress-bar");
                if (progressBar) {
                    progressBar.style.opacity = "0";
                    progressBar.style.visibility = "hidden";
                }
                const loaderSubtitle = document.querySelector(".loader-subtitle");
                if (loaderSubtitle) {
                    loaderSubtitle.style.opacity = "1";
                    loaderSubtitle.style.visibility = "visible";
                }
            }

            gsap.to(overlayLoader, {
                opacity: 0,
                duration: 0.5,
                ease: "power2.inOut",
                onComplete: () => {
                    if (homeBanner) {
                        homeBanner.style.display = "block";
                        homeBanner.style.opacity = "1";
                        homeBanner.style.visibility = "visible";
                    }
                    if (companyBanner) {
                        companyBanner.style.display = "block";
                        companyBanner.style.opacity = "1";
                        companyBanner.style.visibility = "visible";
                    }
                    if (casesBanner) {
                        casesBanner.style.display = "block";
                        casesBanner.style.opacity = "1";
                        casesBanner.style.visibility = "visible";
                    }
                    if (wrapHomeBanner) {
                        wrapHomeBanner.classList.remove("is-inview");
                        setTimeout(() => wrapHomeBanner.classList.add("is-inview"), 20);
                    }
                    if (wrapCompanyBanner) {
                        wrapCompanyBanner.classList.remove("is-inview");
                        setTimeout(() => wrapCompanyBanner.classList.add("is-inview"), 20);
                    }
                    if (wrapCasesBanner) {
                        wrapCasesBanner.classList.remove("is-inview");
                        setTimeout(() => wrapCasesBanner.classList.add("is-inview"), 20);
                    }
                    if (pageCompany) {
                        pageCompany.querySelectorAll(".split-lines h1").forEach((el) => {
                            el.classList.remove("is-inview");
                            setTimeout(() => el.classList.add("is-inview"), 20);
                        });
                    }
                    if (pageCases) {
                        pageCases.querySelectorAll(".split-lines h1").forEach((el) => {
                            el.classList.remove("is-inview");
                            setTimeout(() => el.classList.add("is-inview"), 20);
                        });
                    }
                    document.dispatchEvent(new CustomEvent("loaderComplete"));

                    overlayLoader.style.display = "none";

                    setTimeout(() => {
                        document.dispatchEvent(new CustomEvent("videoScaleAdjust"));
                    }, 50);
                },
            });
        });
    }

    const runFirstLoadLogic = () => {
        if (!sessionStorage.getItem("firstLoadDone")) {
            sessionStorage.setItem("firstLoadDone", "true");
            if (overlayLoader) {
                overlayLoader.style.display = "flex";
                setTimeout(() => {
                    overlayLoader.classList.add("showLoader");
                }, 50);
            }
            startLoader();
            if (wrapHomeBanner) wrapHomeBanner.classList.remove("is-inview");
            if (wrapCompanyBanner) wrapCompanyBanner.classList.remove("is-inview");
            if (wrapCasesBanner) wrapCasesBanner.classList.remove("is-inview");
            if (homeBanner) homeBanner.style.display = "none";
            if (companyBanner) companyBanner.style.display = "none";
            if (casesBanner) casesBanner.style.display = "none";
        } else {
            if (wrapHomeBanner) wrapHomeBanner.style.opacity = "1";
            if (wrapCompanyBanner) wrapCompanyBanner.style.opacity = "1";
            if (wrapCasesBanner) wrapCasesBanner.style.opacity = "1";
            if (homeBanner) {
                homeBanner.style.display = "block";
                homeBanner.style.opacity = "1";
                homeBanner.style.visibility = "visible";
            }
            if (companyBanner) {
                companyBanner.style.display = "block";
                companyBanner.style.opacity = "1";
                companyBanner.style.visibility = "visible";
            }
            if (casesBanner) {
                casesBanner.style.display = "block";
                casesBanner.style.opacity = "1";
                casesBanner.style.visibility = "visible";
            }
            if (overlayLoader) {
                overlayLoader.style.display = "none";
                overlayLoader.classList.remove("showLoader");
            }
        }
    };

    if (!isDesktop) {
        setTimeout(() => {
            runFirstLoadLogic();
        }, 0);
    } else {
        runFirstLoadLogic();
    }

    window.addEventListener("scroll", () => {
        if (homeBanner) {
            homeBanner.style.opacity = "1";
            homeBanner.style.visibility = "visible";
            homeBanner.style.display = "block";
        }
        if (companyBanner) {
            companyBanner.style.display = "block";
            companyBanner.style.opacity = "1";
            companyBanner.style.visibility = "visible";
        }
        if (casesBanner) {
            casesBanner.style.display = "block";
            casesBanner.style.opacity = "1";
            casesBanner.style.visibility = "visible";
        }
    });

    document.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", (event) => {
            const href = link.getAttribute("href");
            if (
                href &&
                !href.startsWith("#") &&
                !href.startsWith("mailto") &&
                !href.startsWith("tel") &&
                !href.startsWith("javascript:void(0)") &&
                !link.hasAttribute("target") &&
                link.classList.contains("go-top")
            ) {
                event.preventDefault();
                overlayLoader.style.display = "none";

                gsap.to(document.body, {
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.inOut",
                    onComplete: () => {
                        transitionOverlay.classList.add("show");
                        setTimeout(() => {
                            window.location.href = href;
                        }, 200);
                    },
                });
            }
        });
    });

    window.addEventListener("pageshow", () => {
        gsap.to(document.body, { opacity: 1, duration: 0.5, ease: "power2.out" });
        transitionOverlay.classList.remove("show");
        if (wrapHomeBanner) {
            wrapHomeBanner.classList.add("is-inview");
        }
    });

    gsap.to("[data-scroll-section]", {
        scrollTrigger: {
            trigger: "[data-scroll-section]",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
        opacity: 1,
    });
});